// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TvInteriorIdCache } from '../Caches/TvInteriorIdCache';
import { DataCache } from '../../DataCache';
import { HistoryType } from '@shared/utils/History/HistoryType';
export class TvDomManager {
    subscribeDepth(symbol, callback) {
        this.domCallback = callback;
        const interiorId = TvInteriorIdCache.getInteriorId(symbol);
        const instrument = DataCache.getInstrumentByName(interiorId);
        if (!isNullOrUndefined(instrument)) {
            DataCache.FQuoteCache.addListener(instrument, this, HistoryType.QUOTE_LEVEL2);
        }
        return interiorId;
    }
    unsubscribeDepth(subscriberUID) {
        const interiorId = TvInteriorIdCache.getInteriorId(subscriberUID);
        const instrument = DataCache.getInstrumentByName(interiorId);
        if (!isNullOrUndefined(instrument)) {
            DataCache.FQuoteCache.removeListener(instrument, this, HistoryType.QUOTE_LEVEL2);
        }
    }
    setCurrentAccount(account) {
        this.curAccount = account;
    }
    newQuote(msg) {
        if (msg.Type === HistoryType.QUOTE_INSTRUMENT_DAY_BAR)
            return;
        if (!this.domCallback)
            return;
        const [askLevel, bidLevel] = this.getDOMData(msg);
        const data = {
            snapshot: true,
            asks: askLevel,
            bids: bidLevel
        };
        this.domCallback(data);
    }
    getDOMData(msg) {
        const interiorId = msg.TargetInstrumentName;
        const instrument = DataCache.getInstrumentByName(interiorId);
        if (isNullOrUndefined(instrument)) {
            console.warn(`getDOMData::Instrument ${interiorId} not found`);
            console.warn(msg);
            return [[], []];
        }
        const lvl2 = instrument.DataCache.FQuoteCache.GetLevel2Cash(instrument);
        const lotSize = instrument.LotSize;
        if (isNullOrUndefined(lvl2))
            return [[], []];
        const account = this.curAccount;
        const sp = DataCache.GetSpreadPlan(account);
        const bidsCollection = lvl2.GetBids(sp);
        const asksCollection = lvl2.GetAsks(sp);
        const bids = this.getDomArray(bidsCollection, true, lotSize);
        const asks = this.getDomArray(asksCollection, false, lotSize);
        return [asks, bids];
    }
    // TODO: Нужно запустить таймер и обновлять данные каждые по времени (как в МД)
    getDomArray(l2Collection, isBid, lotSize) {
        // const keys = Object.keys(l2Collection.items);
        const items = l2Collection.GetSortedList(isBid);
        const domArray = [];
        for (const item of items) {
            const l2 = {
                price: item.Quote.Price,
                volume: item.Quote.Size / lotSize
            };
            domArray.push(l2);
        }
        return domArray;
    }
}
